import type { Column } from '@tanstack/react-table'
import type { ExtendedColumnDef } from '../types/data-table.types'

/**
 * Hook to get column title from header or title property
 */
export function useColumnTitle<TData>() {
  const getColumnTitle = (
    column: Column<TData, unknown> & { columnDef: ExtendedColumnDef<TData, unknown> },
  ): string => {
    const header = column.columnDef.header
    if (typeof header === 'string') {
      return header
    }

    const columnDef = column.columnDef
    if (columnDef.title && typeof columnDef.title === 'string') {
      return columnDef.title
    }

    return column.id.charAt(0).toUpperCase() + column.id.slice(1)
  }

  return {
    getColumnTitle,
  }
}
